import { z } from 'zod';

import { userSchema } from './database.schema';

export const batchCloneJobStatusSchema = z.enum(['PENDING', 'RUNNING', 'SUCCEEDED', 'FAILED']);
export const batchCloneSubmissionStatusSchema = z.enum(['RUNNING', 'SUCCEEDED', 'FAILED']);

export const batchCloneJobHeaderSchema = z.object({
  id: z.string().uuid(),
  status: batchCloneJobStatusSchema,
  sourcePk: z.string().min(1),
  sourceSk: z.string().min(1),
  targetSubmissions: z.array(z.object({ id: z.string().uuid(), name: z.string().optional() })),
  durableExecutionArn: z.string().nullable().optional(),
  created_at: z.string(),
  updated_at: z.string().optional(),
  started_at: z.string().optional(),
  completed_at: z.string().optional(),
  errorMessage: z.string().optional(),
  created_by: userSchema,
});

export const batchCloneJobSubmissionResultSchema = z.object({
  submissionId: z.string().uuid(),
  status: batchCloneSubmissionStatusSchema,
  updated_at: z.string().optional(),
  errorMessage: z.string().optional(),
});

export type BatchCloneJobStatus = z.infer<typeof batchCloneJobStatusSchema>;
export type BatchCloneJobHeader = z.infer<typeof batchCloneJobHeaderSchema>;
export type BatchCloneJobSubmissionResult = z.infer<typeof batchCloneJobSubmissionResultSchema>;
